import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import UseCases from "@/pages/UseCases";
import UseCaseDetail from "@/pages/UseCaseDetail";
import AbsorptionCenter from "@/pages/AbsorptionCenter";
import Integrations from "@/pages/Integrations";
import Admin from "@/pages/Admin";
import AudioLogs from "@/pages/AudioLogs";
import Unauthorized from "@/pages/Unauthorized";

function Spinner() {
  return (
    <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center bg-background">
      <div className="h-10 w-10 rounded-full border-4 border-primary/30 border-t-primary animate-spin" />
    </div>
  );
}

function AdminGuard({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/unauthorized" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { loading } = useAuth();
  if (loading) return <Spinner />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/unauthorized" element={<PublicOnly><Unauthorized /></PublicOnly>} />
      <Route path="/" element={<AdminGuard><Layout /></AdminGuard>}>
        <Route index element={<Dashboard />} />
        <Route path="use-cases" element={<UseCases />} />
        <Route path="use-cases/:uid" element={<UseCaseDetail />} />
        <Route path="absorption" element={<AbsorptionCenter />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="audio-logs" element={<AudioLogs />} />
        <Route path="admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
